import { connect } from 'react-redux';

// selectors
import { getClientBonusScore, getIsLoggedIn } from 'src/store/client/selectors';
import { getIsMobile, getIsWhitelabel } from 'src/store/view/selectors';
import {
  getCashbackLabel,
  getCashbackLabelBackgroundColor,
  getCashbackLabelTextColor,
  getCashbackTooltip,
  getActivateCashbackForPartner,
  getCashbackIconWebp,
  getCashbackIconPng,
} from 'src/store/cashback/selectors';

import { actualizationFetchingWithoutFlightsSelector } from 'checkout/store/selectors/actualization';

import {
  getInstantConfirm,
  getIsManualPackage,
} from 'checkout/store/selectors/package';

import {
  getFlightFuelCharge,
  getOriginalPackageOrderBonuses,
} from 'checkout/store/selectors/order';

import {
  flightsCountSelector,
  minFuelChargeSelector,
} from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/store/flights/selectors';

import { cheapestMandatoryTOExtrasSelector } from 'checkout/store/selectors/services';
import { getSimilarPackagesHasAdjustParams } from 'checkout/store/selectors/similar-packages';

import { skipFlightsAction } from 'checkout/store/actions/order';

import {
  cheapestPreviousPriceSelector,
  discountSelector,
  getCheapestPackagePriceWithAlternatives,
} from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/store/actualize-alternatives';
import { hidePriceChanged } from 'checkout/store/reducers/actualization';
import BillInfo from './BillInfo';

const mapStateToProps = (state) => ({
  activateCashbackForPartner: getActivateCashbackForPartner(state),
  discount: discountSelector(state),
  fetching:
    actualizationFetchingWithoutFlightsSelector(state) ||
    getSimilarPackagesHasAdjustParams(state),
  minimalFuelCharge: minFuelChargeSelector(state),
  fuelCharge: getFlightFuelCharge(state),
  flightLength: flightsCountSelector(state),
  oldPrice: cheapestPreviousPriceSelector(state),
  netPrice: getCheapestPackagePriceWithAlternatives(state),
  instantConfirm: getInstantConfirm(state),
  mandatoryExtras: cheapestMandatoryTOExtrasSelector(state),
  isManualPackage: getIsManualPackage(state),
  isMobile: getIsMobile(state),
  bonuses: getOriginalPackageOrderBonuses(state),
  isWhiteLabel: getIsWhitelabel(state),
  isLoggedIn: getIsLoggedIn(state),
  clientCashback: getClientBonusScore(state),
  labelColor: getCashbackLabelBackgroundColor(state),
  textColor: getCashbackLabelTextColor(state),
  cashbackTooltipText: getCashbackTooltip(state),
  cashbackLabel: getCashbackLabel(state),
  cashbackIconWebp: getCashbackIconWebp(state),
  cashbackIconPng: getCashbackIconPng(state),
});

const mapDispatchToProps = {
  closePriceNotice: hidePriceChanged,
  skipFlights: skipFlightsAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(BillInfo);
